import React from 'react'
import { navigate } from '@reach/router'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import qs from 'qs'
import { Page } from 'components'
import SearchBar from 'views/Activities/SearchBar'
import Results from './Results'

const BASE_PATH = '/schools-activity'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

const SchoolsActivity = (props) => {
  const { location } = props
  location.period = 0

  const classes = useStyles()

  const handleFilter = (values) => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true }) || {}
    const newParams = {
      ...queryParams,
      ...values,
      page: 0,
    }
    const newSearchString = qs.stringify(newParams)
    navigate(`${BASE_PATH}?${newSearchString}`)
  }

  const handleSearch = (value) => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true }) || {}
    const newParams = {
      ...queryParams,
      search: value,
    }
    const newSearchString = qs.stringify(newParams)
    navigate(`${BASE_PATH}?${newSearchString}`)
  }

  const handleReset = () => {
    navigate(BASE_PATH)
  }

  return (
    <Page className={classes.root} title="Aktivitet skoler">
      <Typography component="h1" variant="h3" gutterBottom>
        Aktivitet skoler
      </Typography>
      <SearchBar
        location={location}
        onFilter={handleFilter}
        onSearch={handleSearch}
        handleReset={handleReset}
        basePath={BASE_PATH}
      />
      <Results className={classes.results} location={location} />
    </Page>
  )
}

export default SchoolsActivity
